import React, { useState, useEffect } from "react";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Subscribe from "./Subscribe";

const notify = () => toast.warning("Danger");

function HomeScreen() {
  const [fileName, setFileName] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch(
        "https://localhost:44365/api/Newsletters/file/8/filename"
      );
      const result = await response.json();
      setFileName(result.filename);
    };

    fetchData();
  }, []);

  const handleDownload = async () => {
    setLoading(true);
    const response = await fetch(
      "https://localhost:44365/api/Newsletters/file/8"
    );
    const blob = await response.blob();
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${fileName}`;
    document.body.appendChild(link);
    link.click();
    setLoading(false);
  };

  // useEffect(() => {
  //   fetch("https://localhost:44365/api/Newsletters/file/8")
  //     .then((response) => {
  //       response.blob().then((blob) => {
  //         setFile(URL.createObjectURL(blob));
  //       });
  //     })
  //     .catch((error) => console.error(error));
  // }, []);
  return (
    <div>
      <>
        <button disabled={loading} onClick={handleDownload}>
          Download PDF
        </button>
        {loading && <div>Downloading...</div>}
      </>
    </div>
  );
}

export default HomeScreen;
